import React, { Component } from "react";
import {
    msalApp,
    requiresInteraction,
    fetchMsGraph,
    isIE,
    GRAPH_ENDPOINTS,
    GRAPH_SCOPES,
    GRAPH_REQUESTS,
    checkMemberGroup,
    getUserPhoto
} from "./auth-utils";
import ApplicationConstants from "./Utilities/ApplicationConstants";
import App from "./App";
import ApiCall from './Utilities/ApiCall';

// If you support IE, our recommendation is that you sign-in using Redirect APIs
const useRedirectFlow = isIE();
// const useRedirectFlow = true;

export default C =>
    class AuthProvider extends Component {
        constructor(props) {
            super(props);

            this.state = {
                account: null,
                error: null,
                emailMessages: null,
                graphProfile: null,
                graphAccessToken: null,
                isAuthorized: null,
                userPhoto: null,
                accessToken: null,
                sessionTimeOut: null
            };
        }

        async acquireToken(request, redirect) {
            return msalApp.acquireTokenSilent(request).catch(error => {
                // Call acquireTokenPopup (popup window) in case of acquireTokenSilent failure
                // due to consent or interaction required ONLY
                if (requiresInteraction(error.errorCode)) {
                    return redirect
                        ? msalApp.acquireTokenRedirect(request)
                        : msalApp.acquireTokenPopup(request);
                } else {
                    console.error('Non-interactive error:', error.errorCode)
                    this.setState({ error: error.message });
                }
            });
        }

        async acquireApiToken(redirect, graphResponse) {
            this.setState({ accessToken: null, graphAccessToken: null, sessionTimeOut: null });
            const settings = ApplicationConstants.AppSettings[ApplicationConstants.EnvironmentType];
            const response = await this.acquireToken({
                scopes: [`api://${settings.ClientId}/access_as_user`],
                redirectUri: settings.RedirectUri
            }, redirect).catch(error => {
                this.setState({ error: error.message });
            });

            if (response) {
                this.setState({
                    accessToken: response.accessToken,
                    graphAccessToken: graphResponse.accessToken,
                    sessionTimeOut: Math.min(response.expiresOn.getTime(), graphResponse.expiresOn.getTime()) - Date.now()
                });
            }
            return response;
        }

        async onSignIn(redirect) {
            if (redirect) {
                return msalApp.loginRedirect(GRAPH_REQUESTS.LOGIN);
            }

            const loginResponse = await msalApp
                .loginPopup(GRAPH_REQUESTS.LOGIN)
                .catch(error => {
                    this.setState({
                        error: error.message
                    });
                });

            if (loginResponse) {
                this.setState({
                    account: loginResponse.account,
                    error: null
                });
                const tokenResponse = await this.acquireToken(
                    GRAPH_REQUESTS.LOGIN
                ).catch(error => {
                    this.setState({
                        error: error.message
                    });
                });

                if (tokenResponse && await this.acquireApiToken(redirect, tokenResponse)) {
                    const graphProfile = await fetchMsGraph(
                        GRAPH_ENDPOINTS.ME,
                        tokenResponse.accessToken
                    ).catch(() => {
                        this.setState({
                            error: "Unable to fetch Graph profile."
                        });
                    });

                    if (graphProfile) {
                        this.setState({
                            graphProfile
                        });
                    }
                    if (tokenResponse.scopes.indexOf(GRAPH_SCOPES.MAIL_READ) > 0) {
                        return this.readMail(tokenResponse.accessToken);
                    }
                }

            }
        }

        onSignOut() {
            msalApp.logout();
        }

        async onRequestEmailToken() {
            const tokenResponse = await this.acquireToken(
                GRAPH_REQUESTS.EMAIL,
                useRedirectFlow
            ).catch(e => {
                this.setState({
                    error: "Unable to acquire access token for reading email."
                });
            });

            if (tokenResponse) {
                return this.readMail(tokenResponse.accessToken);
            }
        }

        async readMail(accessToken) {
            const emailMessages = await fetchMsGraph(
                GRAPH_ENDPOINTS.MAIL,
                accessToken
            ).catch(() => {
                this.setState({
                    error: "Unable to fetch email messages."
                });
            });

            if (emailMessages) {
                this.setState({
                    emailMessages,
                    error: null
                });
            }
        }

        async componentWillMount() {
            msalApp.handleRedirectCallback(error => {
                if (error) {
                    const errorMessage = error.errorMessage ? error.errorMessage : "Unable to acquire access token.";
                    // setState works as long as navigateToLoginRequestUrl: false
                    this.setState({
                        error: errorMessage
                    });
                }
            });

            await ApiCall.CallApiGet(ApplicationConstants.EndPoints.GetEnvironmentVariable).then((response) => {
                ApplicationConstants.EnvironmentType = response;
            })
            console.log(ApplicationConstants.EnvironmentType);
            GRAPH_REQUESTS.LOGIN.redirectUri = ApplicationConstants.AppSettings[ApplicationConstants.EnvironmentType]?.RedirectUri;
            msalApp.clientId = ApplicationConstants.AppSettings[ApplicationConstants.EnvironmentType]?.ClientId;
            if (ApplicationConstants) {

            }
            const account = msalApp.getAccount();
            this.setState({
                account
            });

            if (account && this.state.graphProfile == null) {
                const tokenResponse = await this.acquireToken(
                    GRAPH_REQUESTS.LOGIN,
                    useRedirectFlow
                );

                if (tokenResponse && await this.acquireApiToken(useRedirectFlow, tokenResponse)) {
                    const graphProfile = await fetchMsGraph(
                        GRAPH_ENDPOINTS.ME,
                        tokenResponse.accessToken
                    ).catch(() => {
                        this.setState({
                            error: "Unable to fetch Graph profile."
                        });
                    });

                    if (graphProfile) {
                        this.setState({
                            graphProfile
                        });

                        var groupIdArray = [];
                        ApplicationConstants.SecurityGroupDetails[ApplicationConstants.EnvironmentType].forEach(function (groupDetail) {
                            if (Array.isArray(groupDetail.securityGroupId)) {
                                groupDetail.securityGroupId.forEach(function (sgId) {
                                    groupIdArray.push(sgId);
                                })
                            } else {
                                groupIdArray.push(groupDetail.securityGroupId);
                            }
                        })
                        console.log(groupIdArray)

                        const graphGroupResponse = await checkMemberGroup(GRAPH_ENDPOINTS.GROUP,
                            tokenResponse.accessToken, groupIdArray).catch(() => {
                                this.setState({
                                    error: "Unable to authorize"
                                });
                            });
                        //const data = await graphGroupResponse.json();
                        if (graphGroupResponse.value) {
                            graphGroupResponse.value.forEach(function (graphResponseGroupId) {
                                ApplicationConstants.SecurityGroupDetails[ApplicationConstants.EnvironmentType].forEach(function (groupInfo, index) {
                                    if (groupInfo.securityGroupId.includes(graphResponseGroupId)) {
                                        ApplicationConstants.SecurityGroupDetails[ApplicationConstants.EnvironmentType][index].isAuthorized = true;
                                    }
                                })
                            })
                            console.log(ApplicationConstants.SecurityGroupDetails[ApplicationConstants.EnvironmentType])
                            graphGroupResponse.value.length > 0 ? this.setState({ isAuthorized: true }) : this.setState({ isAuthorized: true });
                        }

                        const userPhoto = await getUserPhoto(GRAPH_ENDPOINTS.PHOTO,
                            tokenResponse.accessToken).catch(() => {
                                this.setState({
                                    error: "Unable to get user photo"
                                });
                            })
                        if (userPhoto) {
                            this.setState({ userPhoto: userPhoto });
                        }
                    }
                    if (tokenResponse.scopes.indexOf(GRAPH_SCOPES.MAIL_READ) > 0) {
                        return this.readMail(tokenResponse.accessToken);
                    }
                }
            }
            else if (!account) {
                this.onSignIn(true);
            }
        }

        render() {
            return (
                <C
                    {...this.props}
                    account={this.state.account}
                    emailMessages={this.state.emailMessages}
                    error={this.state.error}
                    graphProfile={this.state.graphProfile}
                    onSignIn={() => this.onSignIn(true)}
                    onSignOut={() => this.onSignOut()}
                    onRequestEmailToken={() => this.onRequestEmailToken()}
                    graphAccessToken={this.state.graphAccessToken}
                    accessToken={this.state.accessToken}
                    isAuthorized={this.state.isAuthorized}
                    userPhoto={this.state.userPhoto}
                    sessionTimeOut={this.state.sessionTimeOut}
                />
            );
        }
    };